/**
 * Canonical Soteria Data Tape column titles (must stay in sync with
 * src/box/soteriaDataTapeSchema.ts → SOTERIA_DATA_TAPE_COLUMNS).
 */
export const SOTERIA_DATA_TAPE_COLUMNS = [
  'Project Identifier',
  'Type of Sale',
  'Project Due Date',
  'Team (in the bank/seller)',
  'Borrower Name',
  'State of Incorporation',
  'Type of Borrower',
  'Industry',
  'Sector',
  'Region',
  'Borrower Year of Incorporation',
  'Executive Summary',
  'Teaser',
  'Loan Identification ',
  'Total Legal Balance ',
  'Outstanding Principal Balance',
  'Holdback',
  'Judgement Status',
  'Origination Date',
  'Interest Base',
  'Interest Pricing',
  'Current Interest Rate',
  'Maturity Date',
  'Payments Default',
  'Covenants Default',
  'Service of the Loans after the Sale',
  'Secured',
  'Type of Security',
  'Syndicated',
  'Level of Security',
  'Guaranty',
  'Term',
  'Amortization',
  'Recourse',
  'LTV',
  'NOI',
  'Cap Rate',
  'DSCR @Current Interest Rate',
  'GRM',
  'Debt Yield',
  'Term/Covenant 1',
  'Term/Covenant 2',
  'Term/Covenant 3',
  'Full Legal Name',
  'State of Incorporation (Guarantor)',
  'Type',
  'Year of Incorporation',
  'Relationship',
  'Property Identifier',
  'State',
  'Zip code',
  'City',
  'Address',
  'Property type',
  'Built SF',
  'units',
  'Stories',
  'Site Size (Acres)',
  'Year Built/Renovated',
  'Appraisal Date',
  'As Is Value',
  'ARV',
  'Level of Completion',
  'Appraisal Value - Real Estate',
  'Appraisal Value - FF&E',
  'Appraisal Value Total',
  'Yet to be Funded',
  'Occupancy',
  'Annual Rent Income',
  'Annual Net Income',
  'Asset Secures Loan Below',
  'Total Outstanding Balance of Loans in Priority Over the Seller',
  'Asking Price',
  'Minimum Price per $1 (debt)',
  'Date of Last Payment',
  'Monthly Loan Payment',
  'Default Rate',
  'Interest Rate',
  'Portion of Loan to be Sold',
  'Data Room Link',
] as const;

/** Alias used throughout Container Excel Builder. */
export const SOTERIA_COLUMNS: readonly string[] = SOTERIA_DATA_TAPE_COLUMNS;

export function soteriaColumnIndex(field: string): number {
  const normalized = field.trim().toLowerCase();
  return SOTERIA_DATA_TAPE_COLUMNS.findIndex((col) => col.trim().toLowerCase() === normalized);
}

/** Prefer field name over API column_index — indices drift when the schema changes. */
export function resolveSemanticMatchColumnIndex(match: {
  column_index: number;
  soteria_field?: string;
}): number {
  if (match.soteria_field) {
    const fromField = soteriaColumnIndex(match.soteria_field);
    if (fromField >= 0) return fromField;
  }
  return match.column_index;
}
